import {
  Enum_Question_Type,
} from '@cyren/common-lib';

type QuestionTypeGroup = {
  label: string
  items: { type: Enum_Question_Type, label: string, deprecated?: boolean }[]
}

export const questionTypeGroups: QuestionTypeGroup[] = [
  {
    label: 'Input',
    items: [
      { type: Enum_Question_Type.Text, label: 'Short Text Input' },
      { type: Enum_Question_Type.Textarea, label: 'Long Text Input' },
      { type: Enum_Question_Type.Number, label: 'Number Input' },
      { type: Enum_Question_Type.NumberUnitSelect, label: 'Number with Unit Selection' },
      { type: Enum_Question_Type.Range, label: 'Range Selector' },
      { type: Enum_Question_Type.Frequency, label: 'Frequency' },
      { type: Enum_Question_Type.BloodPressure, label: 'Blood Pressure' },
      { type: Enum_Question_Type.Date, label: 'Date' },
      { type: Enum_Question_Type.Time, label: 'Time Picker' },
      { type: Enum_Question_Type.Datetime, label: 'Date & Time' },
      { type: Enum_Question_Type.DatetimeRelativeOnset, label: 'Relative Onset Date & Time' },
      { type: 'multi_text' as Enum_Question_Type, label: 'Multi Text Input' },
      { type: 'multi_text_nested' as Enum_Question_Type, label: 'Multi Text Input (Nested)' },
    ]
  },
  {
    label: 'Select',
    items: [
      { type: Enum_Question_Type.SelectSheet, label: 'Select from Sheet' },
      { type: Enum_Question_Type.Select, label: 'Dropdown Select' },
      { type: Enum_Question_Type.SelectV2, label: 'Dropdown Select (V2)', deprecated: true },
      { type: Enum_Question_Type.SelectCountries, label: 'Select Multiple Countries' },
      { type: Enum_Question_Type.SelectCountry, label: 'Select Country' },
      { type: Enum_Question_Type.SelectAbdLocation, label: 'Select Abdomen Location', deprecated: true }
    ]
  },
  {
    label: 'Symptom Selection',
    items: [
      { type: Enum_Question_Type.SxSelect, label: 'Symptom Selection' },
      { type: Enum_Question_Type.Collapsible, label: 'Collapsible Section' }
    ]
  },
  {
    label: 'Symptom Collection',
    items: [
      { type: Enum_Question_Type.SxCollect, label: 'Symptom Collection' },
      { type: Enum_Question_Type.SxCollectAssociated, label: 'Symptom Collection - Associated' },
      { type: Enum_Question_Type.SxCollectIntelligent, label: 'Symptom Collection - Intelligent' },
    ]
  },
  {
    label: 'Body Selection',
    items: [
      { type: Enum_Question_Type.BodySelect, label: 'Body Selection - Question' },
      { type: Enum_Question_Type.BodySelectBack, label: 'Body Selection - Back' },
      { type: Enum_Question_Type.BodySelectBelly, label: 'Body Selection - Belly' },
      { type: Enum_Question_Type.BodySelectChest, label: 'Body Selection - Chest' },
      { type: Enum_Question_Type.BodySelectHead, label: 'Body Selection - Head' },
      { type: Enum_Question_Type.BodySelectLimbs, label: 'Body Selection - Limbs' },
      { type: Enum_Question_Type.BodySelectSensory, label: 'Body Selection - Sensory' },
      { type: Enum_Question_Type.BodySelectSubpart, label: 'Body Selection - Subpart' },
      { type: Enum_Question_Type.BodySelectWhole, label: 'Body Selection - Whole body' },
    ]
  },
  {
    label: 'Content',
    items: [
      { type: Enum_Question_Type.Image, label: 'Image Upload' },
      { type: Enum_Question_Type.Markdown, label: 'Markdown Content' },
      { type: Enum_Question_Type.DrawBody, label: 'Draw on image' }
    ]
  },
  {
    label: 'Administrative',
    items: [
      { type: Enum_Question_Type.StageMilemarker, label: 'Stage Mile Marker' },
      { type: Enum_Question_Type.DateDob, label: 'Date of Birth' },
      { type: Enum_Question_Type.PhoneNumber, label: 'Phone Number' },
      { type: Enum_Question_Type.Signature, label: 'Signature Field' }
    ]
  },
]
